import 'tom-select/dist/css/tom-select.bootstrap5.css';
import TomSelect from 'tom-select';

document.querySelectorAll('[data-behavior="dropdown"]').forEach((item)=> {
  new TomSelect(item, {
    create: false,
    allowEmptyOption: false //item.dataset.blank || true
  })
})


document.querySelectorAll('[data-behavior="user-autocomplete"]').forEach((item)=> {
  new TomSelect(item, {
    valueField: 'id',
    labelField: 'text',
    searchField: 'text',
    load: function(query, callback) {
      if (!query.length) return callback();
      const url = '/users.json?q=' + encodeURIComponent(query);
      fetch(url)
        .then(response => response.json())
        .then(json => {
          callback(json);
        }).catch(() => {
          callback();
        });
    },
    placeholder: "Search user by email or name...",
    create: false,
    allowEmptyOption: true
  });
});
